import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/lt.ts
var add = "Pridėti";
var remove = "Pašalinti";
var removeAll = "Pašalinti visus";
var incomplete = "Atsiprašome, ne visi laukai užpildyti teisingai.";
var submit = "Pateikti";
var noFiles = "Nepasirinktas joks failas";
var moveUp = "Aukštyn";
var moveDown = "Žemyn";
var isLoading = "Kraunama...";
var loadMore = "Daugiau";
var next = "Kitas";
var prev = "Ankstesnis";
var addAllValues = "Pridėti visas reikšmes";
var addSelectedValues = "Pridėti pasirinktas reikšmes";
var removeAllValues = "Pašalinti visas reikšmes";
var removeSelectedValues = "Pašalinti pasirinktas reikšmes";
var chooseDate = "Pasirinkti datą";
var changeDate = "Pakeisti datą";
var close = "Uždaryti";
var open = "Atidaryti";
var accepted = function({
  name
}) {
  return `Prašome priimti ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} turi būti po ${date(args[0])}.`;
  }
  return `${sentence(name)} turi būti ateityje.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} gali būti tik abėcėlės simboliai.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} gali būti tik raidės ir skaičiai.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} gali būti tik raidės ir tarpai.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} turi būti abėcėlės simbolių.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} turi būti raidžių arba skaičių.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} turi būti raidžių arba tarpų.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} turi būti simbolių.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} turi būti didžioji raidė.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} turi būti mažoji raidė.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} turi būti skaičių.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} turi būti simbolis.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} turi būti tik didžiosios raidės.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} turi būti tik mažosios raidės.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} turi būti prieš ${date(args[0])}.`;
  }
  return `${sentence(name)} turi būti praeityje.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Šis laukas buvo sukonfigūruotas neteisingai ir jo negalima pateikti.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} turi būti tarp ${a} ir ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nesutampa.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nėra tinkama data, naudokite formatą ${args[0]}`;
  }
  return "Šis laukas buvo sukonfigūruotas neteisingai ir jo negalima pateikti";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} turi būti tarp ${date(args[0])} ir ${date(args[1])}`;
};
var email = "Įveskite teisingą el. pašto adresą.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} nesibaigia su ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nėra leistina reikšmė.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} turi būti bent vienas simbolis.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} turi būti mažiau arba lygiai ${max2} ${getByQuantity(max2, "simbolis", "simboliai", "simbolių")}.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} turi būti iš ${max2} ${getByQuantity(max2, "simbolio", "simbolių", "simbolių")}.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} turi būti daugiau arba lygiai ${min2} ${getByQuantity(min2, "simbolis", "simboliai", "simbolių")}.`;
  }
  return `${sentence(name)} turi būti tarp ${min2} ir ${max2} simbolių.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nėra leistina reikšmė.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Negali turėti daugiau nei ${args[0]} ${name}.`;
  }
  return `${sentence(name)} turi būti mažiau arba lygiai ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Neleidžiami jokie failų formatai.";
  }
  return `${sentence(name)} turi būti tokio tipo: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Negali turėti mažiau nei ${args[0]} ${name}.`;
  }
  return `Turi būti bent ${args[0]} ${name} .`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nėra leidžiamas ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} turi būti skaičius.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" arba ")} yra privaloma.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} yra privaloma.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} neprasideda su ${list(args)}.`;
};
var url = function() {
  return `Įveskite teisingą URL.`;
};
var invalidDate = "Pasirinkta data yra netinkama.";
function getByQuantity(quantity, vienetas, vienetai, vienetu) {
  const lastTwoDigits = quantity.toString().slice(-2);
  const parsedQuantity = parseInt(lastTwoDigits);
  if (parsedQuantity > 10 && parsedQuantity < 20 || parsedQuantity % 10 === 0) {
    return vienetu;
  }
  if (parsedQuantity === 1 || parsedQuantity % 10 === 1) {
    return vienetas;
  }
  return vienetai;
}
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var lt_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, lt_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=lt.mjs.map